import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

export const logout = async () => {
  return wretchClient
    .url('/admin/1.0/logout')
    .post()
    .res()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
